import { createFileRoute } from '@tanstack/react-router';
import { AdminTopicsView } from '@/components/admin/AdminTopicsView';

export const Route = createFileRoute('/_authed/admin/topics/')({
  component: AdminTopicsView,
});
